
const controllerLoad = () => {

  const pageControllerName = document.querySelector('main.cviceni').id;

  // - inject:js
  // - end inject:js

};

export default controllerLoad;
